import _ from 'lodash'
import DividedByProvider from './DividedByProvider'
import Overall from './Overall'
import Divided from './Divided'
import TotalOverall from './TotalOverall'
import TotalDivided from './TotalDivided'
import TotalDividedByProvider from './TotalDividedByProvider'

export function safeDivide(left, right) {
  const result = left / right

  return _.isNaN(result) || !_.isFinite(result) ? 0 : result
}

export function percent(left, right) {
  return safeDivide(left, right) * 100
}

export function decorate(value, options = {}) {
  const { prefix, postfix, round, percent } = options

  let middle = _.round(value, round || 2)

  if (percent) {
    middle = `${middle * 100}%`
  }

  return [prefix, middle, postfix].filter((val) => !_.isNil(val)).join(' ')
}

export function avg(array) {
  return safeDivide(_.sum(array), array.length)
}

export function zeroWhenIsNil(value) {
  return _.isNil(value) ? 0 : value
}

export function calculateStatistics(statisticsType, statistics, providers) {
  switch (statisticsType) {
    case 'divided':
      return new Divided(statistics, providers).calculate()
    case 'overall':
      return new Overall(statistics).calculate()
    default:
      if (_.includes(providers, statisticsType)) {
        return new DividedByProvider(statistics, statisticsType).calculate()
      }

      return []
  }
}

export function calculateExtraStatisticsFields(statistics) {
  const { spent, clicks, impressions, counterImpressions, goals, providerName } = statistics

  const ctr = safeDivide(clicks, impressions)
  const cpc = safeDivide(spent, clicks)
  const cpm = safeDivide(spent * 1000, impressions)
  const goalPrice = safeDivide(spent, goals)
  const goalPercentage = safeDivide(goals, counterImpressions)

  return {
    providerName,
    goals,
    spent,
    clicks,
    impressions,
    counterImpressions,
    ctr,
    cpc,
    cpm,
    goalPrice,
    goalPercentage
  }
}

export function drawZeroStatistics(provider) {
  return {
    provider,
    spent: 0,
    impressions: 0,
    clicks: 0,
    ctr: 0,
    cpc: 0,
    cpm: 0,
    goalPrice: 0,
    goalPercentage: 0
  }
}

export function calculateTotalStatistics(rawStatistics, statisticsType, providers) {
  if (statisticsType === 'divided') {
    return new TotalDivided(rawStatistics, providers).calculate()
  }

  if (statisticsType === 'overall') {
    return new TotalOverall(rawStatistics).calculate()
  }

  if (_.includes(providers, statisticsType)) {
    return new TotalDividedByProvider(rawStatistics, statisticsType).calculate()
  }

  throw new Error(`statisticsType is not implemented`)
}
